import { BoxProps, TextInputNewProps } from '@jfs/ui-new'
import { StyleSheet, TextInputProps } from 'react-native'

const shadow = {
  shadowColor: 'black',
  shadowOffset: {
    width: 0,
    height: 0.5,
  },
  shadowOpacity: 0.1,
  shadowRadius: 3,
  elevation: 2,
}

export const styles = {
  mainView: {
    flexDirection: 'row',
    justify: 'space-between',
  } as BoxProps,
  searchBox: {
    bg: 'LIGHTEST_GREY',
    width: 200,
    borderWidth: 1,
    borderRadius: 5,
    borderColor: 'GREY_1_SEPARATOR',
    height: 35,
  } as TextInputNewProps,
  container: (transparentBg: boolean | undefined, fullWidth: boolean | undefined) =>
    ({
      ...shadow,
      flexDirection: 'row',
      backgroundColor: transparentBg ? 'TRANSPARENT' : 'LIGHTEST_GREY',
      paddingHorizontal: 16,
      borderWidth: 1,
      borderColor: 'DARK_GREY_BORDER',
      alignItems: 'center',
      width: fullWidth ? '100%' : 250,
      borderRadius: 10,
      height: 38,
    } as BoxProps),
  input: (hideLeftIcons: boolean, fontSize: number | undefined, transparentBg: boolean | undefined) =>
    ({
      flex: 1,
      height: '85%',
      marginLeft: 2,
      fontSize: fontSize ?? 14,
      ...StyleSheet.absoluteFillObject,
      textAlignVertical: 'center',
      paddingTop: 0,
      paddingBottom: 0,
      fontFamily: 'jiotype-medium',
      // outlineColor: transparentBg ? 'TRANSPARENT' : 'LIGHTEST_GREY',
      outlineColor: transparentBg ? 'TRANSPARENT' : '#EFEFEF',
      width: '85%',
      paddingLeft: hideLeftIcons ? 12 : 43,
      alignSelf: 'center',
      marginTop: 2,
    } as TextInputProps),
  rightIconContainer: {
    position: 'absolute',
    underlayColor: 'TRANSPARENT',
    right: 12,
  } as BoxProps,
}
